<template>
  <div>
    <ca-page>
      <ca-heading
        :text="headingTitle"
        size="medium"></ca-heading>
      <span class="ca-u-color-red">* Campos obrigatórios</span>

      <ca-loader v-if="showLoading"></ca-loader>
      <div v-else>
        <ca-form
          :key="formKey"
          ref="caForm"
          :is-valid.sync="isFormValid"
          :on-submit="onSubmit"
          :on-submit-success="onSubmitSuccess"
          :on-submit-error="onSubmitError"
          :error-message="errorMessage">
          <ca-tabs
            :active.sync="activeTab"
            :on-change="onChangeTab"
            theme="white"
            class="ca-u-margin-top">
            <ca-tab label="Dados básicos">
              <worker-basic-data-tab
                :worker-id="workerId"
                :worker-registration="workerRegistration"
                :picture="workerRegistrationPicture"
                @refresh-form="refreshForm"
                @picture-selected="onPictureSelected"></worker-basic-data-tab>
            </ca-tab>

            <ca-tab label="Documentos">
              <worker-documents-tab
                :worker-id="workerId"
                :worker-registration="workerRegistration"></worker-documents-tab>
            </ca-tab>

            <ca-tab label="Endereço">
              <worker-address-tab
                :worker-id="workerId"
                :worker-registration="workerRegistration"
                @refresh-form="refreshForm"></worker-address-tab>
            </ca-tab>

            <ca-tab label="Dependentes">
              <worker-dependents-tab
                :worker-id="workerId"
                :worker-registration="workerRegistration"
                @refresh-form="refreshForm"></worker-dependents-tab>
            </ca-tab>

            <ca-tab label="Adicionais">
              <worker-additional-options-tab
                :worker-id="workerId"
                :worker-registration="workerRegistration"
                @refresh-form="refreshForm"></worker-additional-options-tab>
            </ca-tab>

            <ca-tab label="Anexos">
              <worker-attachments-tab :is-edit-mode="true"></worker-attachments-tab>
            </ca-tab>
          </ca-tabs>

          <ca-footer>
            <ca-row vertical-offset="2">
              <ca-col size="2">
                <ca-button full-width @click="goBack">
                  {{ activeTab > 0 ? 'Voltar' : 'Cancelar' }}
                </ca-button>
              </ca-col>
              <ca-col
                v-if="!isLastTab"
                offset="6"
                size="2">
                <ca-button
                  theme="secondary"
                  full-width
                  @click="onNext">
                  Próximo
                </ca-button>
              </ca-col>
              <ca-col
                :disabled="!isFormValid"
                :offset="saveButtonOffset"
                size="2">
                <ca-submit-button>
                  Salvar
                </ca-submit-button>
              </ca-col>
            </ca-row>
          </ca-footer>
        </ca-form>
      </div>
    </ca-page>
  </div>
</template>

<script>
import { getScrollPosition, setScrollPosition } from 'packages/common/utils';
import {
  getRegistrationWorkerSaveMessage,
} from './workerRegistrationService';
import WorkerBasicDataTab from './components/WorkerBasicDataTab';
import WorkerDocumentsTab from './components/WorkerDocumentsTab';
import WorkerAddressTab from './components/WorkerAddressTab';
import WorkerAdditionalOptionsTab from './components/WorkerAdditionalOptionsTab';
import WorkerAttachmentsTab from './components/worker-attachments-tab/WorkerAttachmentsTab';
import WorkerDependentsTab from './components/worker-dependents-tab/WorkerDependentsTab';
import { TABS_WORKER_REGISTRATION_LENGTH } from '../../workerConstants';
import { WorkerPersonalDataMixin } from '../../mixins/WorkerPersonalDataMixin';
import store from '../../../../store/index';

export default {
  name: 'WorkerRegistrationFormPage',
  components: {
    WorkerBasicDataTab,
    WorkerDocumentsTab,
    WorkerAddressTab,
    WorkerAdditionalOptionsTab,
    WorkerAttachmentsTab,
    WorkerDependentsTab,
  },
  mixins: [WorkerPersonalDataMixin],
  data() {
    return {
      formKey: 0,
      activeTab: 0,
      isFormValid: false,
      errorMessage: null,
    };
  },
  computed: {
    headingTitle() {
      return `Dados pessoais de ${this.workerBasicInfo?.name || ''}`;
    },
    isLastTab() {
      return this.activeTab === TABS_WORKER_REGISTRATION_LENGTH;
    },
    saveButtonOffset() {
      return this.isLastTab ? 8 : 0;
    },
  },
  async created() {
    await store.dispatch('worker/refreshWorkerBasicInfo', this.workerId);
    store.dispatch('breadcrumb/setBreadcrumbProps', { workerName: this.workerBasicInfo.name });
    this.initDataMixin();
  },
  methods: {
    onChangeTab(tabIndex) {
      this.activeTab = tabIndex;
    },
    async refreshForm() {
      this.$refs.caForm.modelValidators = [];
      const currentScrollPosition = getScrollPosition();
      await this.$nextTick();

      this.formKey++;
      await this.$nextTick();

      setScrollPosition(currentScrollPosition);
    },
    onSubmitSuccess() {
      this.$router.push({ name: 'WorkerPage' });
      this.$toaster.success(getRegistrationWorkerSaveMessage());
    },
    onNext() {
      this.activeTab++;
      this.refreshForm();
    },
    onPrevious() {
      this.activeTab--;
      this.refreshForm();
    },
    goBack() {
      if (this.activeTab > 0) {
        this.onPrevious();
      } else if (this.workerBasicInfo.personalDataProvided) {
        this.$router.back();
      } else {
        this.$caConfirm({
          title: 'Excluir "Dados pessoais"',
          message: 'Realizando esta ação você está prestes a excluir os dados pessoais.'
            + ' Você tem certeza de que deseja excluir este registro?',
          onConfirm: () => {
            this.$router.push({ name: 'WorkerPage' });
          },
        });
      }
    },
  },
};
</script>
